import React from 'react';
import PropTypes from 'prop-types';

const CustomTh = ({
    children,
    content,
    hide,
    show,
    width,
    ...passThroughProps
}) => {

    const displayClasses = hide ? `d-none d-${hide}-table-cell` : show ? `d-table-cell d-${show}-none` : '';

    const widthStyle = width ? { width: width } : {}

    return (
        <th
            {...passThroughProps}
            className={`${passThroughProps.className || ''} ${displayClasses} `}
            style={{ ...passThroughProps.style, ...widthStyle }}
        >
            {content}
            {children}
        </th>
    );
}

CustomTh.propTypes = {
    content: PropTypes.string,
    hide: PropTypes.string
};

export default CustomTh;